import styled from 'styled-components';
import { ServiceStatus } from '../../../types/enums';

interface IContainerProps {
  status: ServiceStatus;
}

export const Container = styled.div<IContainerProps>`
  border: solid 2px
    ${({ theme, status }) =>
      status === ServiceStatus.CANCELED ? theme.colors.gray : theme.colors.primary};
  border-radius: 1rem;
  width: auto;
  padding: 1rem;
  margin: 0.5rem;

  .buttons-request {
    display: flex;
    width: 90%;
    justify-content: flex-end;
    margin-top: 2rem;
    border-top: 1px solid ${({ theme }) => theme.colors.tertiary_500};

    .baseButtonRequest {
      width: 20%;
      height: 1.8rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 2rem;
      font-weight: 300;
      transition: all linear 300ms;
      font-size: 1.2rem;
      margin-top: 0.5rem;
      border: solid 1px ${({ theme }) => theme.colors.secondary};
      color: ${({ theme }) => theme.colors.background_white};
      background: ${({ theme }) => theme.colors.secondary};

      &:hover {
        opacity: 0.5;
      }
    }
  }

  .buttons {
    border-top: 1px solid ${({ theme }) => theme.colors.tertiary_500};
    margin-top: 2rem;

    .buttons-demand {
      display: flex;
      margin: auto;
      width: 95%;
      justify-content: space-around;
      padding: 0.5rem;
      margin-right: 2rem;
      align-items: center;

      .baseButtonDemand {
        width: 12rem;
        height: 1.8rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2rem;
        font-weight: 300;
        transition: all linear 300ms;
        font-size: 1.2rem;
        transition: opacity 0, 5s;
        border: solid 1px ${({ theme }) => theme.colors.secondary};
        color: ${({ theme }) => theme.colors.background_white};
        background: ${({ theme }) => theme.colors.secondary};

        &:hover {
          opacity: 0.6;
        }
      }

      .button-back-historic {
        width: 12rem;
        height: 1.8rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2rem;
        font-weight: 300;
        transition: all linear 300ms;
        font-size: 1.2rem;
        margin-top: 0.5rem;
        transition: opacity 0, 5s;
        border: solid 1px ${({ theme }) => theme.colors.secondary};
        color: ${({ theme }) => theme.colors.background_white};
        background: ${({ theme }) => theme.colors.secondary};

        &:hover {
          opacity: 0.5;
        }
      }
    }
  }

  .containerDataSolicitation {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .btnHistoric {
    color: ${({ theme }) => theme.colors.tertiary_500};
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    font-weight: 300;
    gap: 0.5rem;
    text-transform: none;
    border-radius: 1rem;
    margin: 0.5rem 0;

    svg {
      fill: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  .contentOpenInformation {
    display: flex;
    flex-direction: column;

    .containerData {
      display: flex;
      flex-direction: row;
      gap: 1rem;

      .containerInfos {
        display: flex;
        gap: 0.5rem;
        width: 75%;
        padding: 2rem 0.5rem;
        gap: 10rem;
        h1 {
          color: ${({ theme }) => theme.colors.secondary};
          font-size: 1.3rem;
          font-weight: 500;
        }

        p {
          color: ${({ theme }) => theme.colors.text_gray};
          font-size: 1rem;
        }

        border-right: 1px solid ${({ theme }) => theme.colors.text_gray};
      }

      .containerCounterProposal {
        width: 38%;
      }
    }

    .containerButons {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2rem;
      margin-top: 1rem;
    }

    .containerCounterProposal {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      padding: 0 0.5rem;

      h1 {
        color: ${({ theme }) => theme.colors.secondary};
        font-size: 1.3rem;
      }

      p {
        color: ${({ theme }) => theme.colors.primary};
      }

      .contentButton {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  @media (max-width: 690px) {
    .containerDataSolicitation {
      flex-direction: column;
      max-height: 25rem;
      overflow-y: scroll;
      overflow-x: hidden;
    }

    .contentOpenInformation .containerData {
      flex-direction: column;

      .containerInfos {
        width: -webkit-fill-available;
        border-right: none;
      }

      .containerCounterProposal {
        width: -webkit-fill-available;

        div {
          width: -webkit-fill-available;
          align-self: center;
        }
      }
    }
  }

  @media (max-width: 380px) {
    .contentOpenInformation .containerData {
      .containerInfos {
        flex-direction: column;
        align-items: start;
        padding: 0.5rem 0 0 0;
      }

      .containerCounterProposal {
        padding: 0;
      }
    }

    .buttons .buttons-demand {
      justify-content: center;
    }
  }
`;

export const Header = styled.header<IContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-height: 4rem;
  width: 100%;

  .icon-header {
    width: 4rem;
    height: 4rem;
    color: ${({ theme }) => theme.colors.secondary};
  }

  .containerGrid {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .containerStatus {
      display: flex;
      align-items: center;
      .protocol {
        color: ${({ theme }) => theme.colors.text};
        font-weight: 400;
      }
      .createdAt {
        color: ${({ theme }) => theme.colors.secondary};
        font-weight: 400;
        span {
          color: ${({ theme }) => theme.colors.text};
          font-weight: 400;
        }
      }
    }
    .statusCard {
      font-weight: 400;
      font-size: 1rem;
      color: ${({ theme, status }) =>
        status === ServiceStatus.IN_APPROVAL_REQUESTER ||
        status === ServiceStatus.IN_APPROVAL_APPROVER
          ? theme.colors.secondary
          : status === ServiceStatus.CONCLUED
          ? theme.colors.primary
          : status === ServiceStatus.IN_PROGRESS
          ? theme.colors.secondary
          : status === ServiceStatus.CANCELED
          ? theme.colors.gray
          : theme.colors.error};
    }
  }

  .title {
    font-weight: 700;
    color: ${({ theme, status }) =>
      status === ServiceStatus.CANCELED ? theme.colors.gray : theme.colors.secondary};
    font-size: 1.5rem;
    text-overflow: ellipsis;

  }

  p {
    margin-left: 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .container-header {
    display: flex;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .container-header-info {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    width: 90%;

    p {
      color: ${({ theme, status }) =>
        status === ServiceStatus.CANCELED ? theme.colors.gray : theme.colors.secondary};
    }

    .icon-title-status {
      display: flex;
      width: 50%;

      svg {
        width: 4rem;
      }
    }

    .deadline {
      width: 40%;
    }
  }

  @media (max-width: 700px) {
    .container-header-info {
      width: 90%;
      margin: 1 auto; 
      display: flex;
      justify-content: space-between;
    }

    .container-header-info h1 {
      font-size: 1.2rem;
    }

    .container-header-info p {
      font-size: 1.2rem; 
      line-height: 1.4; 
    }

    .container-header-info button,
    .container-header-info a {
      font-size: 0.8rem;
      padding: 8px 12px; 
    }

    body {
      padding: 10px; 
    }

    .container-header-info img {
      max-width: 100%; 
      height: auto; 
    }

    .deadline p {
      text-overflow: ellipsis;
    }
  }

  @media(max-width: 400px){
    .container-header-info {
      width: 65%;
   }
  } 

  img {
    width: 4rem;
  }

  svg {
    color: ${({ theme }) => theme.colors.tertiary_500};
    font-size: 24px;
  }

  .containerButton {
    width: auto;
    display: flex;
    justify-content: end;
  }

  @media (max-width: 950px) {
    .container-header-info .icon-title-status .icon-header {
      width: 3rem;
      height: 3rem;
    }

    .container-header-info .address {
      display: none;
    }
  }

  @media (max-width: 500px) {
    .container-header-info .icon-title-status .icon-header {
      display: none;
    }

    .container-header-info .icon-title-status .containerGrid p {
      margin-left: 0px;
    }

    .container-header-info .specialty {
      display: none;
    }

    .container-header-info .icon-title-status {
      width: 50%;
    }

    .container-header .icon-header {
      display: none;
    }

    .container-header .containerGrid p {
      margin-left: 0px;
    }

    .title {
      font-size: 1.2rem;
    }
    
    .statusCard {
      font-size: 1rem;
    }
  }

  @media (max-width: 350px) {
    .container-header-info {
      width: 85%;
    }

    .container-header-info .icon-title-status {
      width: 55%;
    }
  }
`;

export const Content = styled.div`
  display: flex;

  .containerCard {
    width: 100%;
    display: flex;
    gap: 0.5rem;

    .containerOptions {
      width: 17%;
      margin-left: 0.5rem;
    }

    .containerCenterSolicitation {
      display: flex;
      flex-direction: row;
      width: 100%;
    }

    .containerAdditionalValue {
      min-width: 35%;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #8d8d8d;
      margin-bottom: 1rem;
      gap: 0.5rem;

      .contentAdditionalValue {
        flex-direction: column;
        padding-left: 0.9rem;
        gap: 0.5rem;

        h1 {
          color: ${({ theme }) => theme.colors.secondary};
          font-size: 1.3rem;
        }

        p {
          color: ${({ theme }) => theme.colors.primary};
        }
      }

      .contentButton {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 0.9rem;
        gap: 0.5rem;
      }
    }
  }

  @media (max-width: 690px) {
    .containerCard {
      flex-direction: column;
      gap: 1rem;
      max-height: 25rem;
      overflow-y: scroll;
      overflow-x: hidden;

      .containerOptions {
        width: 100%;
      }

      .containerCenterSolicitation {
        flex-direction: column;
        gap: 1rem;
      }

      .containerAdditionalValue {
        width: -webkit-fill-available;
        border-left: none;

        .contentAdditionalValue,
        .contentButton {
          padding-left: 0;

          .buttonAdditionalValue {
            width: 50% !important;
          }
        }
      }
    }
  }

  @media (max-width: 350px) {
    .containerCard .containerAdditionalValue .contentButton .buttonAdditionalValue {
      width: 80% !important;
    }
  }
`;
